
function stripHtmlTagsAndAmps(html) {
  'use strict';
  return html.replace(/<([^>]+)>/gi, '').replace(/&amp;/g, '&');
}

module.exports = {
  sanitizeContext: function (description) {
    'use strict';
    if (!description) {
      return description;
    }
    const contextWithKeywordsEncoded = description
      .replace(/^[^<]+>/gi, '') // search api context can sometimes return half html tags at the start if there is a very long <a href="{very long href"> in the text
      .replace(/<span class="keyword">([^<]+)<\/span>/gi, '##%##$1%%#%%'); // replace keyword tags by something else in order not lose them in the next step
    const contextWithOtherHtmlTagsRemoved = stripHtmlTagsAndAmps(contextWithKeywordsEncoded);
    return contextWithOtherHtmlTagsRemoved.replace(
      /##%##((?:(?!%%#%%).)+)%%#%%/gi,
      '<span class="keyword">$1</span>'
    ); // return context decoded again: return the keword tags
  },

  getFields: function (goals, curriculumManager) {
    'use strict';
    const fields = [];

    if (goals) {
      goals.forEach(function (goal) {
        var fieldHref = goal.ancestors.find(ancestor => ancestor.type === 'CURRICULUM_ZILL_DEVELOPMENT_FIELD').href;

        curriculumManager.getFieldByHref(fieldHref).then(function (field) {
          if (typeof field != 'undefined' && !fields.some(fieldAlreadyPushed => fieldAlreadyPushed.key === field.key)) {
            fields.push(field);
          }
        });
      });
    }

    return fields;
  }
};



// WEBPACK FOOTER //
// ./web/js/screen/bib/search/bibSearchHelper.js